import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { FamilyWizardModel } from '../../../shared/models/family-wizard.model';
import { ServiceWizard } from '../../../shared/state/service-wizard/service-wizard.model';
import { ProductWizard } from '../../../shared/state/product-wizard/product-wizard.model';
import { map } from 'rxjs/operators';
import { FamilyFolderModel } from '../../../shared/models/family-folder.model';
import { PackWizard } from 'src/app/shared/state/pack-wizard/pack-wizard.model';

@Injectable({
    providedIn: 'root',
})
export class CommonWizardService {
    constructor() {}

    getFamiliesCommonFactor(families: FamilyWizardModel[]) {
        const sourceFamilies = families.filter(
            (family) => family.id === family.sourceId
        );

        families
            .filter((family) => family.id !== family.sourceId)
            .forEach((family) => {
                const existSourceFamily = sourceFamilies.filter(
                    (sourceFamily) => {
                        return (
                            (sourceFamily.id === family.sourceId ||
                                sourceFamily.sourceId === family.sourceId) &&
                            family.folderSourceId ===
                                sourceFamily.folderSourceId
                        );
                    }
                );
                if (existSourceFamily.length === 0) {
                    sourceFamilies.push(family);
                } else {
                    existSourceFamily[0].familiesCommonFactor.push(family.id);
                }
            });

        return sourceFamilies;
    }

    selectFamilyFolderTree(
        familiesWizard$: Observable<FamilyWizardModel[]>,
        servicesWizard$: Observable<ServiceWizard[]>,
        productsWizard$: Observable<ProductWizard[]>,
        packsWizard$: Observable<PackWizard[]>
    ) {
        return combineLatest([
            familiesWizard$,
            servicesWizard$,
            productsWizard$,
            packsWizard$
        ]).pipe(
            map(([families, services, products, packs]) => {
                const familyFolders: { [key: string]: FamilyFolderModel[] } = {};
    
                const familyFolderRoot: FamilyFolderModel = {
                    id: '',
                    description: 'root',
                    parentId: '',
                    parentSourceId: '',
                    families: [],
                    services: [],
                    products: [],
                    packs: [],
                    familiesCommonFactor: [],
                };
    
                familyFolders['0'] = [familyFolderRoot];
    
                families.forEach((family) => {
                    const newFamilyFolder = {
                        id: family.id,
                        description: family.description,
                        parentId: family.folderId,
                        parentSourceId: family.folderSourceId,
                        families: [],
                        services: [],
                        products: [],
                        packs: [],
                        familiesCommonFactor: family.familiesCommonFactor,
                    };
                    if (familyFolders[family.sourceId]) {
                        familyFolders[family.sourceId].push(newFamilyFolder);
                    } else {
                        familyFolders[family.sourceId] = [newFamilyFolder];
                    }
                });
    
                services.forEach((service) => {
                    if (familyFolders[service.familySourceID]) {
                        familyFolders[service.familySourceID].forEach(
                            (familyFolder) => {
                                if (
                                    familyFolder.familiesCommonFactor.some(
                                        (familyCombineFactorId) => {
                                            return (
                                                familyCombineFactorId ===
                                                service.familyId
                                            );
                                        }
                                    )
                                ) {
                                familyFolder.services.push(service);
                            }
                            }
                        );
                    } else {
                        familyFolders[0][0].services.push(service);
                    }
                });

                packs.forEach((pack) => {
                    const folders = familyFolders[pack.familySourceId];
                    let added = false;
                
                    if (folders) {
                        folders.forEach((familyFolder) => {
                            if (familyFolder.familiesCommonFactor.includes(pack.familyId)) {
                                familyFolder.packs.push(pack);
                                added = true;
                            }
                        });
                    }
                
                    if (!added) {
                        familyFolders['0'][0].packs.push(pack);
                    }
                });
                                             
    
                products.forEach((product) => {
                    if (familyFolders[product.familySourceId]) {
                        familyFolders[product.familySourceId].forEach(
                            (familyFolder) => {
                                if (
                                    familyFolder.familiesCommonFactor.some(
                                        (familyCombineFactorId) => {
                                            return (
                                                familyCombineFactorId ===
                                                product.familyId
                                            );
                                        }
                                    )
                                ) {
                                familyFolder.products.push(product);
                            }
                            }
                        );
                    } else {
                        familyFolders[0][0].products.push(product);
                    }
                });
    
                for (const [, familyFolderGroup] of Object.entries(
                    familyFolders
                )) {
                    familyFolderGroup.forEach((familyFolder) => {
                        if (familyFolder.parentSourceId !== '') {
                            if (familyFolders[familyFolder.parentSourceId]) {
                                familyFolders[
                                    familyFolder.parentSourceId
                                ].forEach((currentFamilyFolder) => {
                                    if (
                                        currentFamilyFolder.familiesCommonFactor.some(
                                            (familyCombineFactorId) => {
                                                return (
                                                    familyCombineFactorId ===
                                                    familyFolder.parentId
                                                );
                                            }
                                        ) ||
                                        currentFamilyFolder.id === ''
                                    ) {
                                        currentFamilyFolder.families.push(
                                            familyFolder
                                        );
                            }
                        });
                    } else {
                                familyFolders['0'][0].families.push(
                                    familyFolder
                                );
                            }
                    }
                });
                }
    
                /** Ordenamos alfabéticamente las familias, servicios y productos
                 * Borramos las familias vacías */
                for (const [, familyFolder] of Object.entries(familyFolders)) {
                    familyFolder.forEach((currentFamilyFolder, indexGroup) => {
                        currentFamilyFolder.families = currentFamilyFolder.families.sort(
                            (a, b) =>
                                a.description > b.description
                                    ? 1
                                    : b.description > a.description
                                    ? -1
                                    : 0
                        );

                        currentFamilyFolder.services = currentFamilyFolder.services.sort(
                            (a, b) =>
                                a.description > b.description
                                    ? 1
                                    : b.description > a.description
                                    ? -1
                                    : 0
                        );

                        currentFamilyFolder.products = currentFamilyFolder.products.sort(
                            (a, b) =>
                                a.description > b.description
                                    ? 1
                                    : b.description > a.description
                                    ? -1
                                    : 0
                        );

                        this.deleteEmptyFamily(
                            currentFamilyFolder,
                            familyFolders
                        );
                    });
                }
    
                return familyFolderRoot;
            })
        );
    }

    /** Función recursiva que se va borrando familias vacías hacía arriba en el árbol */
    deleteEmptyFamily(familyFolder: FamilyFolderModel, familyFolders) {
        if (this.isFamilyEmpty(familyFolder)) {
            if (familyFolder.parentSourceId !== '') {
                if (familyFolders[familyFolder.parentSourceId]) {
                    familyFolders[familyFolder.parentSourceId].forEach(
                        (currentFamilyFolderToDelete) => {
                            if (
                                currentFamilyFolderToDelete.familiesCommonFactor.some(
                                    (familyCombineFactorId) => {
                                        return (
                                            familyCombineFactorId ===
                                            familyFolder.parentId
                                        );
                                    }
                                ) ||
                                currentFamilyFolderToDelete.id === ''
                            ) {
                                currentFamilyFolderToDelete.families = currentFamilyFolderToDelete.families.filter(
                                    (family) => {
                                        return family.id !== familyFolder.id;
                                    }
                                );

                                if (
                                    this.isFamilyEmpty(
                                        currentFamilyFolderToDelete
                                    )
                                ) {
                                    this.deleteEmptyFamily(
                                        currentFamilyFolderToDelete,
                                        familyFolders
                                    );
                                }
                            }
                        }
                    );
                }
            }
        }
    }

    isFamilyEmpty(familyFolder) {
        return (
            familyFolder.families?.length === 0 &&
            familyFolder.services?.length === 0 &&
            familyFolder.products?.length === 0
        );
    }
}
